// Inline spoiler: a short run of text blurred/blacked out until the reader
// clicks it (rendered from BBCode [ISPOILER] and the editor's inline-spoiler
// button as <span class="pe-inline-spoiler">). Visual is driven entirely by
// app.css; here we just toggle the `is-revealed` class on click.
//
// Uses one delegated listener so Livewire morphs / navigation need no re-init.

function start() {
    document.addEventListener('click', (event) => {
        const el = event.target.closest && event.target.closest('.pe-inline-spoiler')
        if (!el) {
            return
        }
        el.classList.toggle('is-revealed')
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
} else {
    start()
}
